// extracted by mini-css-extract-plugin
export default {"newBookingButton":"jAPkJdHIiPfw9M0gMdkK"};